import { Component, inject, EventEmitter, Output, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterLink, RouterLinkActive],
  template: `
    <aside class="sidebar" [class.collapsed]="collapsed">
      <div class="sidebar-header">
        <div class="logo-box">
          <svg viewBox="0 0 595.28 595.28" class="logo-icon" xmlns="http://www.w3.org/2000/svg">
            <path fill="#C8A96B" d="M295.06,375.66L205.66,97.77H65.01v29.23h4.66c31.3,0,42.73,3.41,46.81,6.27,5.5,3.87,8.29,12.19,8.29,24.74v253.76c0,22.01-3.83,36.86-11.41,44.14-7.5,7.31-23.14,11.45-46.51,12.3l-4.49.17v29.13h154.87v-28.98l-4.32-.31c-21.68-1.54-36.37-6.13-43.7-13.68-7.42-7.54-11.19-21.93-11.19-42.77V147.94l111.94,349.34h22.21l115.08-351.57v291.48c0,12.74-2.84,21.07-8.48,24.78-4.24,2.85-16.28,6.24-49.53,6.24h-4.66v29.3h188.34v-29.3h-4.66c-34.84,0-47.2-3.39-51.47-6.27-5.6-3.68-8.45-12.01-8.45-24.75V158.01c0-12.24,2.66-20.4,7.87-24.25,3.95-2.85,16-6.33,51.01-6.77l4.6-.06v-29.16h-145.08l-91.68,277.89Z"/>
          </svg>
          <div class="logo-text" *ngIf="!collapsed">
            <span class="logo-title">GRUPO MADERO</span>
            <span class="logo-sub">PátioControl</span>
          </div>
        </div>
        <button class="toggle-btn" (click)="toggleCollapse()">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline *ngIf="!collapsed" points="11 17 6 12 11 7"></polyline>
            <polyline *ngIf="collapsed" points="13 7 18 12 13 17"></polyline>
          </svg>
        </button>
      </div>

      <nav class="nav-menu">
        <a routerLink="/dashboard" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Dashboard' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="3" width="7" height="7" rx="1"></rect><rect x="14" y="14" width="7" height="7" rx="1"></rect><rect x="3" y="14" width="7" height="7" rx="1"></rect></svg>
          <span class="nav-label" *ngIf="!collapsed">Dashboard</span>
        </a>
        <a routerLink="/veiculos" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Veículos' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle></svg>
          <span class="nav-label" *ngIf="!collapsed">Veículos</span>
        </a>
        <a routerLink="/atividades" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Atividades' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><path d="M9 14l2 2 4-4"></path></svg>
          <span class="nav-label" *ngIf="!collapsed">Atividades</span>
        </a>
        <a routerLink="/questionarios" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Construtor' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15 1.65 1.65 0 0 0 3.09 14H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6 1.65 1.65 0 0 0 10 3.09V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>
          <span class="nav-label" *ngIf="!collapsed">Construtor</span>
        </a>
        <a routerLink="/relatorios" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Matriz' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="3" y1="15" x2="21" y2="15"></line><line x1="9" y1="3" x2="9" y2="21"></line><line x1="15" y1="3" x2="15" y2="21"></line></svg>
          <span class="nav-label" *ngIf="!collapsed">Matriz</span>
        </a>
        <a routerLink="/usuarios" routerLinkActive="active" class="nav-item" [title]="collapsed ? 'Usuários' : ''">
          <svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
          <span class="nav-label" *ngIf="!collapsed">Usuários</span>
        </a>
      </nav>

      <div class="sidebar-footer">
        <div class="user-profile" *ngIf="!collapsed">
          <div class="avatar">{{ getUserInitials() }}</div>
          <div class="user-details">
            <span class="user-name">{{ userName || 'Usuário' }}</span>
            <a class="btn-logout" (click)="logout()">Sair da conta</a>
          </div>
        </div>
        <div class="user-profile" *ngIf="collapsed">
          <div class="avatar" (click)="logout()" title="Sair da conta">{{ getUserInitials() }}</div>
        </div>
      </div>
    </aside>
  `,
  styles: [`
    .sidebar {
      width: 260px;
      height: 100vh;
      background: #0c0c0e;
      border-right: 1px solid rgba(200, 169, 107, 0.1);
      display: flex;
      flex-direction: column;
      position: fixed;
      left: 0;
      top: 0;
      z-index: 100;
      transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
      overflow: hidden;

      &.collapsed {
        width: 72px;

        .sidebar-header { padding: 20px 0; flex-direction: column; align-items: center; gap: 12px; }
        .logo-box { justify-content: center; }
        .logo-icon { width: 32px; height: 32px; }
        .nav-menu { padding: 12px 8px; }
        .nav-item { justify-content: center; padding: 12px; border-left: none; &.active { border-left: none; border-radius: 10px; } }
        .icon { width: 20px; height: 20px; }
        .sidebar-footer { padding: 16px 0; align-items: center; }
        .toggle-btn { position: static; }
      }
    }

    .sidebar-header {
      padding: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .logo-box { display: flex; align-items: center; gap: 12px; }
    .logo-icon { width: 28px; height: 28px; flex-shrink: 0; transition: all 0.25s ease; }
    .logo-text { display: flex; flex-direction: column; }
    .logo-title { font-size: 13px; font-weight: 700; letter-spacing: 0.5px; color: #C8A96B; line-height: 1.2; }
    .logo-sub { font-size: 10px; color: rgba(255, 255, 255, 0.4); margin-top: 1px; font-weight: 500; }

    .toggle-btn {
      background: none; border: none; color: rgba(255, 255, 255, 0.3); cursor: pointer;
      width: 28px; height: 28px; display: flex; align-items: center; justify-content: center;
      border-radius: 6px; transition: all 0.2s ease; padding: 0; flex-shrink: 0;
      svg { width: 16px; height: 16px; }
      &:hover { color: #C8A96B; background: rgba(200, 169, 107, 0.1); }
    }

    .nav-menu {
      padding: 8px 12px;
      display: flex; flex-direction: column; gap: 2px; flex: 1;
      overflow-y: auto;
    }

    .nav-item {
      display: flex; align-items: center; gap: 12px;
      padding: 10px 12px; border-radius: 8px;
      color: rgba(255, 255, 255, 0.45); text-decoration: none;
      font-size: 13px; font-weight: 500;
      transition: all 0.2s ease;
      border-left: 3px solid transparent;
      white-space: nowrap;

      &:hover { color: rgba(255, 255, 255, 0.85); background: rgba(255, 255, 255, 0.03); }
      &.active {
        background: rgba(200, 169, 107, 0.08);
        color: #fff;
        border-left-color: #C8A96B;
        border-radius: 0 8px 8px 0;
        .icon { color: #C8A96B; }
      }
    }

    .icon { width: 18px; height: 18px; flex-shrink: 0; transition: color 0.2s ease; }
    .nav-label { transition: opacity 0.2s ease; }

    .sidebar-footer {
      padding: 16px 20px;
      border-top: 1px solid rgba(255, 255, 255, 0.04);
      display: flex; flex-direction: column; gap: 12px;
    }

    .user-profile { display: flex; align-items: center; gap: 10px; }
    .avatar {
      width: 34px; height: 34px; border-radius: 10px; flex-shrink: 0;
      background: linear-gradient(135deg, rgba(200, 169, 107, 0.2), rgba(200, 169, 107, 0.05));
      color: #C8A96B; display: flex; align-items: center; justify-content: center;
      font-size: 12px; font-weight: 700; border: 1px solid rgba(200, 169, 107, 0.2);
    }
    .user-details { display: flex; flex-direction: column; min-width: 0; }
    .user-name { font-size: 12px; font-weight: 600; color: #fff; overflow: hidden; text-overflow: ellipsis; }
    .btn-logout {
      font-size: 10px; color: rgba(255, 255, 255, 0.35); text-decoration: none;
      cursor: pointer; transition: color 0.2s ease; margin-top: 1px;
      &:hover { color: #f87171; }
    }
  `]
})
export class SidebarComponent {
  private authService = inject(AuthService);
  userName = this.authService.getUserName();
  @Input() collapsed = false;
  @Output() collapsedChange = new EventEmitter<boolean>();

  getUserInitials(): string {
    const name = this.userName || 'US';
    return name.substring(0, 2).toUpperCase();
  }

  toggleCollapse(): void {
    this.collapsed = !this.collapsed;
    this.collapsedChange.emit(this.collapsed);
  }

  logout(): void {
    this.authService.logout();
  }
}
